import BarChart from "./BarChart";

export default BarChart;



// WEBPACK FOOTER //
// ./src/legacy-tv-ui/BarChart/index.js